<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    width="600px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>{{ $t('ChannelWarehouseManagement.form.Basic') }} </BjDivider>

    <el-col :span="22">
      <el-form-item :label="$t('ChannelWarehouseManagement.form.code')" prop="code">
        <span v-if="!isEdit">{{ $t('ChannelWarehouseManagement.form.autoCode') }}</span>
        <span v-if="isEdit">{{ form.code }}</span>
      </el-form-item>
    </el-col>

    <el-col :span="22">
      <el-form-item :label="$t('ChannelWarehouseManagement.form.name')" prop="name">
        <BjInput
          v-model="form.name"
          :maxlength="MAX_LENGTH.DEFAULT"
          :placeholder="$t('inputText')"
        />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { stockApi } from '@/api';
const getDefaultForm = () => {
  return {
    id: null,
    name: null,
    code: null,
    typeCode: 'channel',
    status: true,
    creationDate: null,
  };
};

export default {
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('ChannelWarehouseManagement.form.ruleName'),
            trigger: 'blur',
          },
        ],
      };
    },
  },
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.regionList = [];
      this.$refs.BjDrawerForm.setTitle(
        this.isEdit
          ? this.$t('ChannelWarehouseManagement.form.Edit')
          : this.$t('ChannelWarehouseManagement.form.Create'),
      );
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      this.saveApi(API_DATA);
    },
    reFresh() {
      this.$emit('reFresh');
    },

    // 修改API
    saveApi(API_DATA) {
      stockApi.saveChannelWarehouses(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('WarehouseManagement.form.Saved'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
